module.exports = __webpack_public_path__ + "media/images/athletes/2501-4729ecc02b3920ddd9ba13d359c6d6a2.png";